import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {
    userKey:null,
    token:null,
    tokenExpiredTime:null,
    userId:null,
    tenantId:null,
    userInfo:null
}


// var copyState = deepClone(state) // 拷贝state对象
// function deepClone (obj) {
//   var newObj = obj instanceof Array ? [] : {}
//   for (var i in obj) {
//     newObj[i] = typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i]
//   }
//   return newObj
// }

const getters = {//实时监听state值的变化(最新状态)
    getUserKey(){
        return state.userKey;
    },
    getTenantId(){
        return state.tenantId;
    },
    getToken(){
        return state.token;
    },
    getTokenExpiredTime(){
        return state.tokenExpiredTime
    },
    getUserInfo(){
        return state.userInfo;
    },
    getUserId(){
        return state.userId;
    }
}

const mutations = { //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
    setUserKey(state,userKey){
        state.userKey = userKey;
    },
    setToken(state,token){
        state.token = token;
    },
    setTokenExpiredTime(state,tokenExpiredTime){
        state.tokenExpiredTime = tokenExpiredTime;
    },
    setUserInfo(state,userInfo){
        state.userInfo = userInfo;
    },
    setTenantId(state,tenantId){
        state.tenantId = tenantId
    },
    setUserId(state,userId){
        state.userId = userId
    },
    resetState(state){
        let cloneObj = deepClone(state);
        for(let key in cloneObj){
            state[key] = cloneObj[key]
        }
    }
}

function deepClone (obj) {
    let newObj = obj instanceof Array ? [] : {}
    for (let i in obj) {
        newObj[i] = typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i]
    }
    return newObj
}
 
const actions = {////自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
    setUserKey(context,userKey){
        context.commit('setUserKey',userKey)
    },
    setToken(context,token){
        context.commit('setToken',token)
    },
    setTokenExpiredTime(context,tokenExpiredTime){
        context.commit('setTokenExpiredTime',tokenExpiredTime)
    },
    setUserInfo(context,userInfo){
        context.commit('setUserInfo',userInfo)
    },
    setTenantId(context,tenantId){
        context.commit('setTenantId',tenantId);
    },
    setUserId(context,userId){
        context.commit('setUserId',userId);
    }

}
const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});
 
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js